<div
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  class="gradient-card w-full transition-all duration-300 hover:shadow-2xl animate-slide-up group cursor-pointer"
>
  <div
    [ngClass]="
      compact
        ? 'flex flex-col justify-center items-center gap-4 p-6 sm:p-8 bg-white rounded-2xl shadow-xl h-44 sm:h-48 w-full'
        : 'flex flex-col justify-center items-center gap-6 sm:gap-8 p-8 sm:p-10 bg-white rounded-2xl shadow-xl h-64 sm:h-72'
    "
    [class.border-2]="featured"
    [class.border-warning-500]="featured"
    role="article"
    aria-label="Experience card"
  >
    <h2
      [ngClass]="
        compact
          ? 'text-2xl sm:text-3xl font-poppins font-semibold text-primary-600 text-center leading-snug transition-colors duration-300 group-hover:text-primary-600'
          : 'text-2xl sm:text-3xl font-poppins font-semibold text-primary-600 text-center leading-snug transition-colors duration-300 group-hover:text-primary-600'
      "
    >
      {{ title }}
    </h2>
  </div>
</div>
